export enum BankIDTransactionStatus {
  Pending = 'PENDING',
  Failed = 'FAILED',
  Completed = 'COMPLETED',
  Cancelled = 'CANCELLED',
}
